<template>
  <div class="tss" :class="{ 'tss--wide': wide }" :style="themeVars">
    <div class="tss__col">
    <!-- primary colour -->
      <section class="tss__section">
        <div class="tss__title"><v-icon small>mdi-palette-outline</v-icon>{{ $t('themeSectionColor') }}</div>
        <div class="tss__swatches" role="radiogroup">
          <button
            v-for="c in colors"
            :key="c"
            type="button"
            role="radio"
            class="tss__swatch"
            :class="{ on: sameColor(c, color) }"
            :aria-checked="sameColor(c, color)"
            :style="{ '--sw': c }"
            @click="color = c"
          >
            <v-icon v-if="sameColor(c, color)" small>mdi-check</v-icon>
          </button>
        </div>
      </section>

      <!-- appearance -->
      <section class="tss__section">
        <div class="tss__title"><v-icon small>mdi-monitor-dashboard</v-icon>{{ $t('themeSectionAppearance') }}</div>
        <div class="tss__list">
          <label class="tss__row">
            <span class="tss__row-icon"><v-icon small>mdi-weather-night</v-icon></span>
            <span class="tss__row-text">{{ $t('dark-Mode') }}</span>
            <v-switch v-model="dark" inset hide-details class="tss__switch" />
          </label>
          <label class="tss__row">
            <span class="tss__row-icon"><v-icon small>mdi-format-pilcrow-arrow-left</v-icon></span>
            <span class="tss__row-text">{{ $t('RTL_Mode') }}</span>
            <v-switch v-model="rtl" inset hide-details class="tss__switch" />
          </label>
          <label class="tss__row">
            <span class="tss__row-icon"><v-icon small>mdi-blur</v-icon></span>
            <span class="tss__row-text">{{ $t('appBarsOpacity') }}</span>
            <v-switch v-model="appBarsOpacity" inset hide-details class="tss__switch" />
          </label>
        </div>
      </section>

      <!-- language & date -->
      <section class="tss__section">
        <div class="tss__title"><v-icon small>mdi-earth</v-icon>{{ $t('themeSectionRegion') }}</div>
        <div class="tss__list">
          <div class="tss__row">
            <span class="tss__row-icon"><v-icon small>mdi-translate</v-icon></span>
            <span class="tss__row-text">{{ $t('language') }}</span>
            <language v-model="lang" />
          </div>
          <div class="tss__row">
            <span class="tss__row-icon"><v-icon small>mdi-calendar-month-outline</v-icon></span>
            <span class="tss__row-text">{{ $t('date-type') }}</span>
            <span class="tss__chip">{{ $store.state.date_locale == 'fa,en' ? $t('jalali') : $t('gregorian') }}</span>
          </div>
        </div>
      </section>
    </div>

    <!-- background -->
    <section class="tss__section tss__bg">
      <div class="tss__title"><v-icon small>mdi-image-outline</v-icon>{{ $t('background') }}</div>
      <theme-background />
    </section>
  </div>
</template>

<script>
  // Redesigned copy of core/Settings.vue (original untouched). Script is the
  // original: it posts `this.$data` to `setting`, so data() keys must stay
  // as they are; new UI-only helpers live in computed/methods.
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState } from 'vuex'
  import General from '@/Mixins/general'
  import Language from '../../../LanguageBar'
  import ThemeBackground from './ThemeBackground'
  export default {
    name: 'ThemeSettings',
    components: {
      Language,
      ThemeBackground,
    },

    mixins: [Proxyable, General],
    // Desktop dialog: two columns so the panel fits without scrolling.
    props: {
      wide: { type: Boolean, default: false },
    },
    data: () => ({
      rtl: true,
      settingBtn: true,
      origin: 'top right',
      color: '#E91E63',
      hoverMenu: null,
      appBarsOpacity: null,
      lang: null,
      dark: false,
      styleObject: {
        color: 'red',
        fontSize: '13px',
      },
      colors: [
        '#0066FF',
        '#7c4dff',
        '#00CAE3',
        '#4CAF50',
        '#ff9800',
        '#E91E63',
        '#FF5252',
      ],
      image: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
      images: [
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-2.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-3.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-4.jpg',
      ],
      menu: false,
      saveImage: '',
      showImg: true,
    }),
    computed: {
      ...mapState(['barImage']),
      themeVars () {
        return { '--tss-primary': this.color || '#0066FF' }
      },
    },

    watch: {
      menu (val) {
        // this.settingBtn = !val
      },
      color (val) {
        this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.theme_color.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      showImg (val) {
        if (!val) {
          this.saveImage = this.barImage
          this.setBarImage('')
        } else if (this.saveImage) {
          this.setBarImage(this.saveImage)
          this.saveImage = ''
        } else {
          this.setBarImage(val)
        }
      },
      image (val) {
        this.setBarImage(val)
      },
      rtl (val) {
        this.origin = 'top left'
        this.$vuetify.rtl = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.rtl.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
        this.modifyVuetifyApplication()
      },
      hoverMenu (val) {
        this.origin = 'top left'
        var storage = JSON.parse(localStorage.getItem('token'))
        if (storage.init.hoverMenu) {
          storage.init.hoverMenu.value = val
        } else {
          var hover = { value: val }
          storage.init.hoverMenu = hover
        }
        this.$store.commit('SET_HOVERMENU', val)
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
        this.modifyVuetifyApplication()
      },
      appBarsOpacity (val) {
        this.origin = 'top left'
        var storage = JSON.parse(localStorage.getItem('token'))
        if (storage.init.appBarsOpacity) {
          storage.init.appBarsOpacity.value = val
        } else {
          var appBarsOpacity = { value: val }
          storage.init.appBarsOpacity = appBarsOpacity
        }
        this.$store.commit('SET_APPBARSOPACITY', val)
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      dark (val) {
        this.origin = 'top left'
        this.$vuetify.theme.dark = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.dark.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      lang (val) {
        if (this.lang !== undefined) {
          this.store()
        }
      },
    },

    methods: {
      sameColor (a, b) {
        return String(a || '').toLowerCase() === String(b || '').toLowerCase()
      },
      ...mapMutations({
        setBarImage: 'SET_BAR_IMAGE',
      }),
      store () {
        var app = this
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
      },
    },
    mounted () {
      var store = this.$store.state
      this.color = store.theme_color
      this.rtl = store.rtl
      this.dark = store.dark
      this.hoverMenu = store.hoverMenu
      this.appBarsOpacity = store.appBarsOpacity
    },
  }
</script>

<style scoped>
.tss {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.tss__col {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.tss--wide {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}
.tss--wide .tss__bg ::v-deep .tbg__grid {
  max-height: none;
}
.tss__title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #6b7280;
}
.tss__title .v-icon {
  color: #8a94a6 !important;
}
.theme--dark .tss__title {
  color: #aaa;
}
.tss__swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.tss__swatch {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--sw);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px transparent;
  transition: transform 0.15s, box-shadow 0.15s;
}
.tss__swatch:hover {
  transform: scale(1.08);
}
.tss__swatch.on {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--sw);
}
.theme--dark .tss__swatch {
  box-shadow: 0 0 0 2px #1e1e1e, 0 0 0 3px transparent;
}
.theme--dark .tss__swatch.on {
  box-shadow: 0 0 0 2px #1e1e1e, 0 0 0 4px var(--sw);
}
.tss__swatch .v-icon {
  color: #fff !important;
}
.tss__list {
  border: 1px solid #e8ebf0;
  border-radius: 6px;
  overflow: hidden;
}
.theme--dark .tss__list {
  border-color: #333;
}
.tss__row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 54px;
  padding: 6px 12px;
  cursor: pointer;
}
div.tss__row {
  cursor: default;
}
.tss__row + .tss__row {
  border-top: 1px solid #f0f2f5;
}
.theme--dark .tss__row + .tss__row {
  border-color: #2a2a2a;
}
.tss__row-icon {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f4f9;
}
.theme--dark .tss__row-icon {
  background: #2a2a2a;
}
.tss__row-icon .v-icon {
  color: #5b6475 !important;
}
.theme--dark .tss__row-icon .v-icon {
  color: #ccc !important;
}
.tss__row-text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.88rem;
}
.tss__switch {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto;
}
.tss ::v-deep .tss__switch .v-input--selection-controls__input {
  margin: 0 !important;
}
.tss ::v-deep .tss__switch.v-input--is-label-active .v-input--switch__track,
.tss ::v-deep .tss__switch.v-input--is-label-active .v-input--switch__thumb {
  color: var(--tss-primary) !important;
  caret-color: var(--tss-primary) !important;
}
.tss ::v-deep .v-input {
  height: auto !important;
}
.tss__chip {
  flex: 0 0 auto;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  background: #f1f4f9;
  color: #374151;
}
.theme--dark .tss__chip {
  background: #2a2a2a;
  color: #ddd;
}
</style>
